import { render } from "./ReportInfoGetAndChange.vue?vue&type=template&id=685d54a2&scoped=true"
import script from "./ReportInfoGetAndChange.vue?vue&type=script&lang=js"
export * from "./ReportInfoGetAndChange.vue?vue&type=script&lang=js"

import "./ReportInfoGetAndChange.vue?vue&type=style&index=0&id=685d54a2&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685d54a2"]])

export default __exports__